module.exports = __webpack_public_path__ + "img/login_bg_r.85f59b5c.png";